<template>
    <div>
        <div class="card-header">
            <h3>{{ $t("lang.label_notifications") }}</h3>
        </div>
        <div class="card-body" style="min-height: 200px">
            <div class="row" v-if="isLoading">
                <Loader
                    style="position: inherit !important; height: 0px !important"
                ></Loader>
            </div>
            <div class="row" v-else>
                <form @submit.prevent="SaveForm()" style="width: 100%">
                    <div class="form-group col-md-12">
                        <div style="height: 10px; padding: 14px">
                            <button
                                type="submit"
                                :disabled="btnSave"
                                class="btn btn-success"
                                style="
                                    position: absolute;
                                    right: 0;
                                    margin-top: -5px;
                                    margin-right: 9px;
                                "
                            >
                                <i class="fas fa-save fa-ms"></i>
                                {{ $t("lang.label_save") }}
                            </button>
                        </div>
                    </div>
                    <hr />
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 200px">
                                    {{ $t("lang.label_title") }}
                                </th>
                                <th scope="col" style="width: 200px">
                                    {{ $t("lang.msj_email") }}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="count === 0">
                            <tr>
                                <th colspan="10">
                                    <div style="text-align: center">SIN REGISTRO</div>
                                </th>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(i, index) in noti" :key="index">
                                <td>
                                    <input
                                        type="text"
                                        :maxlength="100"
                                        v-model="i.title"
                                        class="form-control editables"
                                        placeholder="Title"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        :maxlength="100"
                                        v-model="i.email"
                                        class="form-control editables"
                                        placeholder="Email"
                                    />
                                    <div class="timesBtn">
                                        <a
                                            class="btn btn-danger"
                                            @click="delNoti(i)"
                                            style="
                                                padding: 2px !important;
                                                margin-top: 4px;
                                                color: white;
                                            "
                                        >
                                            <i class="fas fa-times fa-ms"></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="form-group col-md-12" v-if="cou">
                        <div style="height: 10px; padding: 14px">
                            <a
                                class="btn btn-info"
                                style="margin-left: -15px; color: white"
                                @click="addInput(1)"
                            >
                                <i class="fas fa-plus fa-ms"></i>
                                {{ $t("lang.label_add_row") }}
                            </a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <notifications
            group="noti"
            position="top center"
            style="margin-top: 50px"
        ></notifications>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import axios from "axios";
export default {
    name: "notification",
    components: {
        Loader,
    },
    data () {
        return {
            btnSave: false,
            isLoading: false,
            dat: [],
            reg: {
                user_id: window.localAccountID,
                org_id: window.localuserdata,
            },
            cou: 1,
            count: 0,
            noti: [],
        }
    },
    created () {
        this.getNotification();
    },
    methods: {
        delNoti(data) {
            if (data.id === 0) {
                this.noti.splice(data.id_item, 1);
                this.getNotification();
            } else {
                this.$swal({
                    title: window.lang2.label_temail,
                    text: window.lang2.msj_you_sure,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: window.lang2.msj_del_it,
                }).then((result) => {
                    if (result.value) {
                        let url = "/menu/delnoti";
                        window.master
                            .post(url, data)
                            .then((response) => {
                                // console.log('del ',response.data)
                                this.getNotification();
                            })
                            .catch((error) => console.log(error));
                    }
                });
            }
        },
        addInput(a) {
            let y = this.noti;
            for (let i = 0; i < a; i++) {
                let co = i + this.count;
                y.push({
                    id: 0,
                    id_item: co,
                    email: "",
                    title: "",
                    status: 1,
                    user_id: window.localAccountID,
                    org_id: window.localuserdata,
                });
            }
            let r = this.noti;
            let u = r.length;
            this.count = u;
            if (u === 3) {
                this.cou = 0;
            }
        },
        SaveForm() {
            this.btnSave = true;
            let re = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            let noty = this.noti;
            let data = [];
            for (const i in noty) {
                if (noty[i].email !== "") {
                    if (!re.test(noty[i].email)) {
                        console.log("formato de email invalid");
                        this.$notify({
                            group: "noti",
                            title: "¡Error!",
                            type: "error",
                            text: window.lang2.msj_valid_email,
                        });
                    } else {
                        // console.log(noty[i]);
                        data.push(noty[i]);
                    }
                }
            }
            let url = "/menu/editNotification";
            window.master
                .post(url, data)
                .then((response) => {
                    console.log(response.data);
                    this.btnSave = false;
                })
                .catch((error) => {
                    this.btnSave = false;
                    console.log(error);
                });
        },
        getNotification() {
            this.isLoading = true;
            let url = "/menu/getNotification";
            window.master
                .post(url, this.reg)
                .then((response) => {
                    // console.log(response.data);
                    this.cou = response.data.cou;
                    this.count = response.data.res.length;
                    this.noti = response.data.res;
                    switch (this.count) {
                        case 0:
                            this.addInput(2);
                            break;
                        case 1:
                            this.addInput(1);
                            break;
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        closeModal() {
            this.$modal.hide("modal-setting");
        },
    },
}
</script>
<style lang="scss" scoped>
.timesBtn {
    position: absolute;
    margin-top: -35px;
    right: 0;
    margin-right: 17px;
}
.btn-add-group {
    background-color: #fff;
    border-color: #ccc;
    cursor: pointer;
    position: relative;
    color: #666;
    width: 100% !important;
}
.form-control.editables {
    border: 1px solid #949698;
}
.table tbody tr:hover {
    background-color: #f1ffff;
}
.table tbody tr td:hover {
    background-color: #fff;
}
</style>
